import ChangeHistory from 'app/shared-components/ChangeHistory'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import requests from 'app/requests/ContractBasis/LaneFees.requests'

const LaneFeesChangeHistory = ({
    id,
}: { id: number }) => {
    return (
        <ChangeHistory
            id={id}
            requestKey={RequestKeys.getLaneFeesModifications}
            config={requests.modifications}
            configName="LaneFeesChangeHistoryTable"
            name="LaneFeesChangeHistory"
            labelPrefixForChangedColumn={['LaneFees']}
            title="Lane Fees Change Summary"
        />
    )
}

export default LaneFeesChangeHistory
